import {Component, inject, input} from '@angular/core';
import {BluetoothSvgComponent, Status} from "src/app/presentation/common/icons/bluetooth-svg/bluetooth-svg.component";
import {Router} from '@angular/router';
import {
  Destination
} from 'src/app/presentation/main-view/add-device/add-proximity-sample-point/add-proximity-sample-point.component';
import {NgClass, SlicePipe} from '@angular/common';
import {UserStore} from 'src/app/domain/user/user.store';

@Component({
  selector: 'app-unassigned-bluetooth-proximity-sensor-button',
  imports: [
    BluetoothSvgComponent,
    NgClass,
    SlicePipe
  ],
  templateUrl: './unassigned-bluetooth-proximity-sensor-button.component.html',
  styleUrl: './unassigned-bluetooth-proximity-sensor-button.component.css'
})
export class UnassignedBluetoothProximitySensorButtonComponent {

  id = input.required<string>();

  Status = Status;

  userStore = inject(UserStore);

  private router = inject(Router);

  onClick() {
    if (!this.userStore.canEdit()) return;

    const id = this.id();
    if (!id) return;

    this.router.navigate(
      ['/main/add-proximity-sample-point'],
      { queryParams: { deviceId: id, destination: Destination.PROXIMITY_SAMPLE_POINTS } }
    );
  }
}
